module.exports = __webpack_public_path__ + "img/Risk_Rate_v3_24@2x.e2bf4ef9.png";